import { getCountryName } from '@mews-commander/legacy-entities/src/ducks/countries';
import { useCommanderSelector } from '@mews-commander/utils';

interface CountryNameProps {
    countryCode?: string | null;
}

export const CountryName = ({ countryCode }: CountryNameProps) => {
    const countryName = useCommanderSelector((state) => getCountryName(state, { countryCode }));

    return <>{countryName}</>;
};
